// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["__sentryRewritesTunnelPath__"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"abbycare-client@0302c26"};globalThis["__sentryBasePath"] = undefined;globalThis["__rewriteFramesAssetPrefixPath__"] = "";import * as Sentry from '@sentry/nextjs'
import { IS_PRODUCTION } from 'utils/constants'

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

// this is not a TS file
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getEnvironment = () => {
  let isStaging = false
  let isPreProd = false

  if (typeof window !== 'undefined') {
    // All non-custom-domain Amplify deploys (staging, pre-prod, etc.) are
    // served from this app id, so use it to detect the shared Amplify domain.
    isStaging = window.location.hostname.includes('d1nneiagifwwvp')
    // While this says production, it actually points to our pre-production
    // branch.
    isPreProd = isStaging && window.location.hostname === 'production.d1nneiagifwwvp.amplifyapp.com'
  }

  if (isPreProd) {
    return 'pre-prod'
  } else if (isStaging) {
    return 'staging'
  } else if (IS_PRODUCTION) {
    return 'production'
  }

  return 'development'
}

// NEXT_PUBLIC_* are inlined at build time (client only sees these); fallback for local/server
const release = process.env.NEXT_PUBLIC_SENTRY_RELEASE || process.env.SENTRY_RELEASE
const dist = process.env.NEXT_PUBLIC_SENTRY_DIST || process.env.SENTRY_DIST

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    release,
    dist,
    environment: getEnvironment(),
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.05,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api\.abbycare\.org/,
      /^https:\/\/api-staging\.abbycare\.org/
    ],
    beforeSend(event, hint) {
      // Fingerprint LaunchDarkly network errors for grouping
      const error = hint.originalException
      const isLaunchDarklyError =
        event.exception?.values?.some((ex) => ex.type === 'LaunchDarklyFlagFetchError') ||
        (error instanceof Error && error.name === 'LaunchDarklyFlagFetchError')

      if (isLaunchDarklyError) {
        event.fingerprint = ['launchdarkly-network-error']
        event.tags = event.tags || {}
        event.tags.source = 'launchDarklyFetchError'
      }

      return event
    },
    integrations: [
      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true
      }),
      Sentry.browserTracingIntegration()
    ]
  })
}
